import { render, staticRenderFns } from "./PageSpeed.vue?vue&type=template&id=0f2e259d&"
import script from "./PageSpeed.vue?vue&type=script&lang=js&"
export * from "./PageSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports